import styled from "styled-components";
import React from "react";

const Root = styled.div`
  background-color: #151a1c;
  text-transform: capitalize;
  display: flex;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: right;
  margin-top: 30px;
  align-items: flex-start;
  width: 100%;
  border-radius: ${(p) => p.theme.radius.sm};
  padding: ${(p) => p.theme.spacing.sm};
  @media (max-width: 768px) {
    margin-top: 15px;
  }
  @media (max-width: 1024px) {
    margin-top: 15px;
  }
`;

const LeftWrapper = styled.div``;
const InfoWrapper = styled.div``;
const Image = styled.img`
  width: 30px;
  /* @media(min-width:1600px){
    width:40px;
} */
`;
const Text = styled.div`
  color: #707070;
  font-size: 18px;
  margin-bottom: 10px;
  @media (min-width: 1800px) {
    
  }
`;
const BoldText = styled.div`
  font-weight: ${(p) => p.theme.font.weight.bold};
  font-size: ${(p) => p.theme.font.size.lg};
  @media (min-width: 1600px) {
    // font-size:${(p) => p.theme.font.size.xl};
  }
`;

const ImageWrapper = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1c2122;
  border-radius: 50%;
  margin-right: ${(p) => p.theme.spacing.sm};
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  :hover,
  :focus,
  :active {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
  }
  @media (max-width: 1600px) {
    width: 65px;
    height: 65px;
  }
  `;

const IconWrapper = styled.div``;
const Icon = styled.div`
margin: 0 10px;
cursor:pointer;
position: relative;
`;
const InfoSectionClick = styled.div`
  position: absolute;
  background-color: #fff;
  border-radius: 10px 10px 10px 0;
  padding: 10px 15px;
  left: 20px;
  top: auto;
  bottom: 35px;
  color: #767676;
  font-size: 14px;
  font-family: lato;
  letter-spacing: 0.1px;
  max-width: 250px;
  width: 250px;
  height: fit-content;
  ${(p) =>
    p.MinimumMLD &&
    `
  left: 48%;
  top: -5%;
  `}
  ${(p) =>
    p.ImmatureWithdrawal &&
    `
    left: 73%;
    top: -5%;
    `}
  
  ${(p) =>
    p.LORDRatio &&
    `
    left: 43%;
    top: -5%;
    `}
    @media (max-width: 1700px) {
      border-radius: 10px 10px 0 10px;
      padding: 10px 15px;
      left: auto;
      bottom: 35px;
      right: 20px;
      top: auto;
    }
    @media (max-width: 1024px) {
      border-radius: 10px 10px 10px 0;
      padding: 10px 15px;
      left: 20px;
      top: -50px;
    }
    @media (max-width: 768px) {
      border-radius: 10px 10px 0 10px;
      padding: 10px 15px;
      left: auto;
      bottom: 35px;
      right: 20px;
      top: auto;
    }
`;
const Card = ({ image, title, data, NoteIcon,onNoteIconClick,isPopUp,activePopUpText,popUpText }) => {
  return (
    <Root>
      <LeftWrapper>
        <ImageWrapper>
          <Image src={image} />
        </ImageWrapper>
      </LeftWrapper>
      <InfoWrapper>
        <Text>{title}</Text>
        <BoldText>{data}</BoldText>
      </InfoWrapper>
        <Icon onClick={onNoteIconClick}>
          <img src={NoteIcon} /> {isPopUp && (
                <InfoSectionClick activePopUpText>
                  {popUpText}
                </InfoSectionClick>
              )}
        </Icon>
       
    </Root>
  );
};

export default Card;
